<app-menu>
  <div class="admin-shell min-h-full bg-[var(--admin-bg)] text-[var(--admin-text)]" [attr.data-theme]="themeMode">
    <div class="mx-auto flex min-h-[calc(100vh-64px)] max-w-[1680px] flex-col gap-3 px-3 py-3 sm:px-4 lg:px-5">
      <section class="admin-panel overflow-hidden p-4">
        <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div class="min-w-0">
            <div class="flex flex-wrap items-center gap-2 text-sm font-semibold text-[var(--admin-muted)]">
              <span class="inline-flex items-center gap-2 rounded-lg border border-[var(--admin-border)] bg-[var(--admin-surface-2)] px-3 py-1.5">
                <i class="fa-solid fa-user-shield text-sky-500"></i>
                User Administration
              </span>
              <span class="inline-flex items-center gap-2 rounded-lg border px-3 py-1.5" [ngClass]="ams_user.status === 1 ? 'border-emerald-500/25 bg-emerald-500/10 text-emerald-500' : 'border-rose-500/25 bg-rose-500/10 text-rose-500'">
                <span class="h-2 w-2 rounded-full" [ngClass]="ams_user.status === 1 ? 'bg-emerald-500' : 'bg-rose-500'"></span>
                {{ ams_user.status === 1 ? 'Active' : 'Inactive' }}
              </span>
            </div>

            <h1 class="mt-3 break-words text-2xl font-black leading-tight text-[var(--admin-text)] sm:text-3xl">
              {{ams_user.email || 'Admin User Manager'}}
            </h1>
            <p class="mt-1 max-w-4xl text-sm font-medium leading-5 text-[var(--admin-muted)]">
              {{persistedRoleSummary}} &middot; {{ams_user.company_name || 'No company set'}} &middot; {{ams_user.domain_name || 'No primary domain'}}
            </p>
          </div>

          <div class="flex flex-wrap items-center gap-3 lg:justify-end">
            <button type="button" class="admin-secondary-button" (click)="toggleTheme()">
              <i [class]="getThemeIcon()"></i>
              <span>{{getThemeLabel()}}</span>
            </button>
          </div>
        </div>

        <div class="mt-4 grid gap-2 sm:grid-cols-2 xl:grid-cols-4">
          <article class="admin-stat">
            <span class="admin-stat-icon bg-sky-500/10 text-sky-500"><i class="fa-solid fa-key"></i></span>
            <div class="min-w-0">
              <p class="admin-stat-label">Roles Mask</p>
              <p class="admin-stat-value">{{persistedRolesMask}}</p>
            </div>
          </article>
          <article class="admin-stat">
            <span class="admin-stat-icon bg-emerald-500/10 text-emerald-500"><i class="fa-solid fa-sitemap"></i></span>
            <div class="min-w-0">
              <p class="admin-stat-label">Menu Access</p>
              <p class="admin-stat-value">{{ams_side_menu_array.length}} / {{ams_side_sub_menu_array.length}} / {{ams_side_sub_sub_menu_array.length}}</p>
            </div>
          </article>
          <article class="admin-stat">
            <span class="admin-stat-icon bg-amber-500/10 text-amber-500"><i class="fa-solid fa-building"></i></span>
            <div class="min-w-0">
              <p class="admin-stat-label">Domains</p>
              <p class="admin-stat-value">{{domains.length}}</p>
            </div>
          </article>
          <article class="admin-stat">
            <span class="admin-stat-icon bg-violet-500/10 text-violet-500"><i class="fa-solid fa-lock"></i></span>
            <div class="min-w-0">
              <p class="admin-stat-label">Permissions</p>
              <p class="admin-stat-value">{{permissions.length}}</p>
            </div>
          </article>
        </div>
      </section>

      <div class="grid gap-3 lg:grid-cols-2">
        <section class="admin-panel p-4">
          <div class="admin-section-header">
            <div>
              <p class="admin-eyebrow">Identity</p>
              <h2 class="admin-section-title">AMS User</h2>
            </div>
          </div>
          <div class="mt-3 grid gap-1">
            <div class="admin-detail-row"><span>Email</span><strong>{{ams_user.email || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Registered</span><strong>{{ams_user.registered || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Last Login</span><strong>{{ams_user.last_login || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Main Domain</span><strong>{{ams_user.domain_name || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Company Name</span><strong>{{ams_user.company_name || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Roles</span><strong>{{persistedRoleSummary}}</strong></div>
          </div>
          <div class="mt-3 grid gap-1 sm:grid-cols-2">
            <mat-checkbox [checked]="ams_user.status === 1" [disabled]="true">Status</mat-checkbox>
            <mat-checkbox [checked]="ams_user.verified === 1" [disabled]="true">Verified</mat-checkbox>
            <mat-checkbox [checked]="ams_user.resettable === 1" [disabled]="true">Resettable</mat-checkbox>
            <mat-checkbox [checked]="ams_user.force_logout === 1" [disabled]="true">Force Logout</mat-checkbox>
            <mat-checkbox [checked]="ams_user.messaging === 1" [disabled]="true">Messaging Enabled</mat-checkbox>
          </div>

          <div *ngIf="canManageUsers" class="mt-4 rounded-lg border border-[var(--admin-border)] bg-[var(--admin-surface-2)] p-3">
            <div class="mb-3 flex flex-wrap items-center justify-between gap-2">
              <div>
                <p class="admin-eyebrow">Landing</p>
                <h3 class="text-base font-black leading-tight text-[var(--admin-text)]">Default Page</h3>
              </div>
              <span *ngIf="defaultRouteHasChanges" class="admin-pill admin-pill--warning">Unsaved changes</span>
            </div>
            <div class="grid gap-3 lg:grid-cols-[minmax(220px,1fr)_auto] lg:items-start">
              <mat-form-field appearance="outline" class="admin-form-field">
                <mat-label>Default Page</mat-label>
                <mat-select [(ngModel)]="selectedDefaultRoute" name="defaultRoute">
                  <mat-option *ngFor="let option of defaultRouteOptions" [value]="option.route">{{option.label}}</mat-option>
                </mat-select>
              </mat-form-field>
              <button type="button" class="admin-primary-button min-h-[48px]" (click)="saveDefaultRoute()" [disabled]="defaultRouteSaving || !defaultRouteHasChanges">
                <i class="fa-solid fa-location-arrow"></i>
                <span>{{ defaultRouteSaving ? 'Saving...' : 'Save Default' }}</span>
              </button>
            </div>
            <div *ngIf="defaultRouteSuccess" class="admin-message admin-message--success mt-3">{{defaultRouteSuccess}}</div>
            <div *ngIf="defaultRouteError" class="admin-message admin-message--error mt-3">{{defaultRouteError}}</div>
          </div>
        </section>

        <section class="admin-panel p-4">
          <div class="admin-section-header">
            <div>
              <p class="admin-eyebrow">External Account</p>
              <h2 class="admin-section-title">API User</h2>
            </div>
          </div>
          <div class="mt-3 grid gap-1">
            <div class="admin-detail-row"><span>User UUID</span><strong>{{api_user?.user_uuid || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Domain UUID</span><strong>{{api_user?.domain_uuid || '-'}}</strong></div>
            <div class="admin-detail-row"><span>API Username</span><strong>{{api_user?.username || '-'}}</strong></div>
            <div class="admin-detail-row"><span>API Key</span><strong>{{api_user?.api_key || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Carrier Contact UUID</span><strong>{{api_user?.carrier_contact_uuid || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Driver Contact UUID</span><strong>{{api_user?.driver_contact_uuid || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Shipper Contact UUID</span><strong>{{api_user?.shipper_contact_uuid || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Consignee Contact UUID</span><strong>{{api_user?.consignee_contact_uuid || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Customer Contact UUID</span><strong>{{api_user?.customer_contact_uuid || '-'}}</strong></div>
          </div>
        </section>
      </div>

      <section *ngIf="canManageUsers" class="admin-panel p-4">
        <div class="admin-section-header">
          <div>
            <p class="admin-eyebrow">Security</p>
            <h2 class="admin-section-title">Change Password</h2>
          </div>
        </div>
        <div class="mt-3 grid gap-3 lg:grid-cols-[minmax(220px,1fr)_minmax(220px,1fr)_auto]">
          <mat-form-field appearance="outline" class="admin-form-field">
            <mat-label>New Password</mat-label>
            <input matInput type="password" [(ngModel)]="newPassword" name="newPassword">
          </mat-form-field>
          <mat-form-field appearance="outline" class="admin-form-field">
            <mat-label>Confirm Password</mat-label>
            <input matInput type="password" [(ngModel)]="confirmPassword" name="confirmPassword">
          </mat-form-field>
          <div class="flex items-start">
            <button type="button" class="admin-primary-button min-h-[48px]" (click)="changeUserPassword()" [disabled]="passwordSaving">
              <i class="fa-solid fa-key"></i>
              <span>{{ passwordSaving ? 'Saving...' : 'Update Password' }}</span>
            </button>
          </div>
        </div>
        <div *ngIf="passwordSuccess" class="admin-message admin-message--success mt-3">{{passwordSuccess}}</div>
        <div *ngIf="passwordError" class="admin-message admin-message--error mt-3">{{passwordError}}</div>
      </section>

      <section *ngIf="canManageUsers" class="admin-panel p-4">
        <div class="admin-section-header">
          <div>
            <p class="admin-eyebrow">Authorization</p>
            <h2 class="admin-section-title">User Roles</h2>
          </div>
          <div class="flex flex-wrap items-center gap-2 text-sm font-semibold text-[var(--admin-muted)]">
            <span class="rounded-lg border border-[var(--admin-border)] bg-[var(--admin-surface-2)] px-3 py-2">Mask {{selectedRolesMask}}</span>
            <span class="rounded-lg border border-[var(--admin-border)] bg-[var(--admin-surface-2)] px-3 py-2">{{selectedRoleSummary}}</span>
          </div>
        </div>
        <div class="mt-3 grid gap-x-3 gap-y-1 rounded-lg border border-[var(--admin-border)] bg-[var(--admin-surface-2)] p-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <mat-checkbox *ngFor="let role of roleOptions" [checked]="isRoleSelected(role.key)" (change)="toggleRole(role.key, $event.checked)">
            {{role.label}}
          </mat-checkbox>
        </div>
        <div class="mt-4 flex flex-wrap items-center gap-3">
          <button type="button" class="admin-primary-button" (click)="saveRoles()" [disabled]="roleSaving">
            <i class="fa-solid fa-user-check"></i>
            <span>{{ roleSaving ? 'Saving...' : 'Save Roles' }}</span>
          </button>
        </div>
        <div *ngIf="roleSuccess" class="admin-message admin-message--success mt-3">{{roleSuccess}}</div>
        <div *ngIf="roleError" class="admin-message admin-message--error mt-3">{{roleError}}</div>
      </section>

      <section class="admin-panel overflow-hidden p-4">
        <div class="admin-section-header">
          <div>
            <p class="admin-eyebrow">Domain Access</p>
            <h2 class="admin-section-title">Multi Domain</h2>
          </div>
          <button *ngIf="canManageUsers" type="button" class="admin-secondary-button" (click)="addDomainAccess()">
            <i class="fa-solid fa-plus"></i>
            <span>Add Domain Access</span>
          </button>
        </div>
        <div class="admin-grid-shell mt-3">
          <ag-grid-angular class="ag-theme-ulaap admin-grid admin-grid--domains" (gridReady)="onDomainGridReady($event)" [defaultColDef]="defaultColDef" [columnDefs]="domainColumnDefs" [rowData]="domains"></ag-grid-angular>
        </div>
      </section>

      <section class="admin-panel overflow-hidden p-4">
        <div class="admin-section-header">
          <div>
            <p class="admin-eyebrow">Permission Matrix</p>
            <h2 class="admin-section-title">Effective Permissions</h2>
          </div>
        </div>
        <div class="admin-grid-shell mt-3">
          <ag-grid-angular class="ag-theme-ulaap admin-grid admin-grid--permissions" (gridReady)="onPermissionGridReady($event)" [defaultColDef]="defaultColDef" [columnDefs]="permissionColumnDefs" [rowData]="permissions"></ag-grid-angular>
        </div>
      </section>

      <div class="grid gap-3 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]">
        <section class="admin-panel p-4">
          <div class="admin-section-header">
            <div>
              <p class="admin-eyebrow">Voice</p>
              <h2 class="admin-section-title">Phone System</h2>
            </div>
            <button *ngIf="canManageUsers" type="button" class="admin-icon-button" matTooltip="Edit Phone System" (click)="editPhoneSystem()">
              <i class="fa-solid fa-pen"></i>
            </button>
          </div>
          <div class="mt-3 grid gap-1">
            <div class="admin-detail-row"><span>Domain</span><strong>{{ams_user.phone_system_domain || '-'}}</strong></div>
            <div class="admin-detail-row"><span>API Key</span><strong>{{ams_user.phone_system_api_key || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Extensions</span><strong>{{ams_user.phone_system_extensions || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Active Extension</span><strong>{{ams_user.phone_system_active_extension || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Gateway</span><strong>{{ams_user.phone_system_gateway || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Caller ID Name</span><strong>{{ams_user.phone_system_caller_id_name || '-'}}</strong></div>
            <div class="admin-detail-row"><span>Caller ID Number</span><strong>{{ams_user.phone_system_caller_id_number || '-'}}</strong></div>
          </div>
        </section>

        <section class="admin-panel p-4">
          <div class="admin-section-header">
            <div>
              <p class="admin-eyebrow">Navigation</p>
              <h2 class="admin-section-title">Menu Access</h2>
            </div>
            <div class="flex flex-wrap items-center gap-2">
              <span *ngIf="!canManageUsers" class="admin-pill">View only</span>
              <span *ngIf="canManageUsers && menuAccessHasChanges" class="admin-pill admin-pill--warning">Unsaved changes</span>
              <span *ngIf="canManageUsers && !menuAccessHasChanges" class="admin-pill admin-pill--success">Saved</span>
              <button *ngIf="canManageUsers" type="button" class="admin-primary-button" (click)="updateMenuAccess()" [disabled]="menuAccessSaving || !menuAccessHasChanges">
                <i class="fa-solid fa-floppy-disk"></i>
                <span>{{ menuAccessSaving ? 'Saving...' : 'Save Menu Access' }}</span>
              </button>
            </div>
          </div>

          <div class="mt-3 grid gap-2 sm:grid-cols-3">
            <div class="admin-mini-stat"><span>Menus</span><strong>{{ams_side_menu_array.length}}</strong></div>
            <div class="admin-mini-stat"><span>Sub Menus</span><strong>{{ams_side_sub_menu_array.length}}</strong></div>
            <div class="admin-mini-stat"><span>Nested</span><strong>{{ams_side_sub_sub_menu_array.length}}</strong></div>
          </div>

          <div *ngIf="menuAccessSuccess" class="admin-message admin-message--success mt-3">{{menuAccessSuccess}}</div>
          <div *ngIf="menuAccessError" class="admin-message admin-message--error mt-3">{{menuAccessError}}</div>

          <div class="admin-tree mt-3 max-h-[560px] overflow-auto rounded-lg border border-[var(--admin-border)] bg-[var(--admin-surface-2)] p-2" *ngIf="sideMenu.length; else noMenuItems">
            <div class="admin-tree-grid">
              <section class="admin-menu-group" *ngFor="let side_menu of sideMenu">
                <mat-checkbox class="admin-tree-parent" [disabled]="!canManageUsers || menuAccessSaving" [checked]="isSideMenuChecked(side_menu.ams_side_menu_id)" (change)="toggleSideMenu(side_menu.ams_side_menu_id, $event.checked)">
                  {{side_menu.ams_side_menu_text}}
                </mat-checkbox>

                <div class="admin-tree-children" *ngIf="getSideSubMenus(side_menu.ams_side_menu_id).length">
                  <section class="admin-tree-child-group" *ngFor="let side_sub_menu of getSideSubMenus(side_menu.ams_side_menu_id)">
                    <mat-checkbox [disabled]="!canManageUsers || menuAccessSaving" [checked]="isSideSubMenuChecked(side_sub_menu.ams_side_sub_menu_id)" (change)="toggleSideSubMenu(side_sub_menu.ams_side_sub_menu_id, side_menu.ams_side_menu_id, $event.checked)">
                      {{side_sub_menu.ams_side_sub_menu_text}}
                    </mat-checkbox>

                    <div class="admin-tree-grandchildren" *ngIf="getSideSubSubMenus(side_sub_menu.ams_side_sub_menu_id).length">
                      <mat-checkbox *ngFor="let side_sub_sub_menu of getSideSubSubMenus(side_sub_menu.ams_side_sub_menu_id)" class="admin-tree-nested" [disabled]="!canManageUsers || menuAccessSaving" [checked]="isSideSubSubMenuChecked(side_sub_sub_menu.ams_side_sub_sub_menu_id)" (change)="toggleSideSubSubMenu(side_sub_sub_menu.ams_side_sub_sub_menu_id, side_sub_menu.ams_side_sub_menu_id, $event.checked)">
                        {{side_sub_sub_menu.ams_side_sub_sub_menu_text}}
                      </mat-checkbox>
                    </div>
                  </section>
                </div>
              </section>
            </div>
          </div>

          <ng-template #noMenuItems>
            <div class="mt-4 rounded-lg border border-dashed border-[var(--admin-border)] bg-[var(--admin-surface-2)] p-6 text-center text-sm font-semibold text-[var(--admin-muted)]">No menu items found.</div>
          </ng-template>
        </section>
      </div>
    </div>
  </div>
</app-menu>
